import PersonInPlaceEditor from './PersonInPlaceEditor';

export default PersonInPlaceEditor;
